// 微信浏览器
function isWXBrowser() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 企业微信
function isWxWorkBrowser() {
  var ua = navigator.userAgent.toLowerCase()
  let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
  console.log(ua)
  if (!isWx) {
    return false
  } else {
    let isWxWork = ua.match(/WxWork/i) == 'wxwork'
    if (isWxWork) {
      return true
    } else {
      return false
    }
  }
}

//QQ浏览器
function isQQBrowser() {
  var ua = navigator.userAgent
  return (
    /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d]+)/.test(ua) ||
    /\bV1_AND_SQI?_([\d]+)(.*? QQ\/([\d]+))?/.test(ua)
  )
}

function isIOSBrowser() {
  return !!navigator.userAgent.match(/iPhone|iPad|iPod|Mac/i)
}

function IsPCBrowser() {
  // 检测常见的移动设备关键词，包含鸿蒙系统标识
  const mobileKeywords =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|HuaweiHarmonyOS/i

  // 如果包含移动设备或鸿蒙系统关键词，判定为移动设备
  if (mobileKeywords.test(navigator.userAgent)) {
    return false
  }

  // 进一步通过屏幕宽度判断（可根据需求调整阈值）
  if (window.screen.width < 768) {
    return false
  }

  return true
}

module.exports = {
  isWXBrowser,
  isIOSBrowser,
  isQQBrowser,
  IsPCBrowser,
  isWxWorkBrowser,
}
